/**
 * Chilll ad-funnel problem steps (popup 1 → 2). Edit labels here.
 */
export const FUNNEL_PROBLEMS = {
  ac: {
    label: "A/C Not Cold",
    emoji: "🌡️",
    header: "So Your A/C isn't Cold.\nWhat's Been Getting in the Way?",
    barrierPrompt: "What's been getting in the way of having it diagnosed?",
    pills: [
      "Probably too expensive",
      "I've Been Busy",
      "Might need a new one",
      "Hate getting bids",
    ],
  },
  faucet: {
    label: "Faucet Drips",
    emoji: "🚰",
    header: "That Dripping Faucet Driving You Crazy?\nWhat's Been Getting in the Way?",
    barrierPrompt: "What's been getting in the way of having it diagnosed?",
    pills: [
      "Seems complicated",
      "Haven't had time",
      "Worried about the cost",
      "Don't know where to start",
    ],
  },
  toilet: {
    label: "Toilet Runs",
    emoji: "🚽",
    header: "Toilet Running Non-Stop?\nWhat's Been Getting in the Way?",
    barrierPrompt: "What's been getting in the way of having it diagnosed?",
    pills: [
      "Not sure what's wrong",
      "Worried it'll get worse",
      "Too busy to deal with it",
      "Afraid of the cost",
    ],
  },
  outlet: {
    label: "Outlet not Working",
    emoji: "⚡",
    header: "That Outlet Still Not Working?\nWhat's Been Getting in the Way?",
    barrierPrompt: "What's been getting in the way of having it diagnosed?",
    pills: [
      "Scared of electrical work",
      "Too expensive to hire out",
      "Don't know the cause",
      "Just been ignoring it",
    ],
  },
};

export const FUNNEL_PROBLEM_KEYS = Object.keys(FUNNEL_PROBLEMS);
